// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2022-11-04
// Modified By: Zachary Thomas
//
// Copyright 2021 - 2022 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { Link } from "react-router-dom";
import PropTypes, { InferProps } from "prop-types";
import { useParams } from "react-router-dom";
import styles from "./NavbarAssetLink.module.scss";

// A single clickable link on a navbar that corresponds to an asset.
export default function NavbarAssetLink(props: Props): Component {
  const { assetId } = useParams<Params>();

  return (
    <li
      className={`${styles.item} mx-3 ${
        props.targetPage.replace("*", assetId || "0") === props.currentPage ? styles.active : ""
      }`}
    >
      <Link className={styles.link} to={props.targetPage.replace("*", assetId || "0")}>
        <span>{props.name}</span>
      </Link>
    </li>
  );
}

NavbarAssetLink.propTypes = {
  name: PropTypes.string.isRequired,
  targetPage: PropTypes.string.isRequired,
  currentPage: PropTypes.string.isRequired,
};

type Props = InferProps<typeof NavbarAssetLink.propTypes>;

type Params = {
  assetId: string;
};
